var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalCameraSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7 1.4C22.5 1.3 22.3 1.3 22.2 1.4L18.7 4.1V2.9C18.7 1.3 17.4 0 15.8 0H2.9C1.3 0 0 1.3 0 2.9V11.9C0 13.5 1.3 14.8 2.9 14.8H15.8C17.4 14.8 18.7 13.5 18.7 11.9V10.7L22.2 13.4C22.3 13.5 22.5 13.5 22.7 13.4C22.9 13.3 23 13.2 23 13V1.8C23 1.6 22.9 1.5 22.7 1.4Z",
    fill: "#D7EED5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCameraSecondary);
export default __webpack_public_path__ + "static/media/modal-camera-secondary.cf9cd8d1eeda572bf65ad9cf591e9d67.svg";
export { ForwardRef as ReactComponent };